<template>
  <div class="merchant-app-list">
    <div class="filter-container">
      <el-button  type="success" size="small" @click="onClickAddBtn">+</el-button>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('merchant.merchant_no')" align="center">
          <template slot-scope="scope">
            {{ scope.row.merchant ? scope.row.merchant.merchant_no : '' }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.merchant_name')" align="center">
          <template slot-scope="scope">
            {{ scope.row.merchant ? scope.row.merchant.merchant_name : '' }}
          </template>
        </el-table-column>
        <!--
        <el-table-column :label="$t('merchant.app_name')" align="center">
          <template slot-scope="scope">
            {{ scope.row.app_name }}
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchant.appkey')" align="center">
          <template slot-scope="scope">
            {{ scope.row.appkey }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.notice_webhook')" align="center">
          <template slot-scope="scope">
            {{ scope.row.notice_webhook }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.qrcode_webhook')" align="center">
          <template slot-scope="scope">
            {{ scope.row.qrcode_webhook }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.transfer_webhook')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transfer_webhook }}
          </template>
        </el-table-column>

        <!--        <el-table-column :label="$t('merchant.collect_url')" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.collect_url }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <!--        <el-table-column :label="$t('merchant.validate_url')" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.validate_url }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <!--操作-->
        <el-table-column :label="$t('components.operation')" :trans-detail="tableData[0]" align="center">
          <template slot-scope="scope">
<!--            <el-button-->
<!--              type="primary"-->
<!--              size="mini"-->
<!--              class="edit-btn"-->
<!--              @click="showUpdateMerchantAppModal(scope.row)"-->
<!--            >{{ $t('components.edit') }}</el-button>-->

            <el-button
              size="mini"
              @click="showMerchantAppDetailModal(scope.row)"
            >{{ $t('components.detail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
      </div>
    </div>

    <add-merchant-app-modal @getMerchantAppList="getMerchantAppList" />
    <update-merchant-app-modal @getMerchantAppList="getMerchantAppList" />
    <merchant-app-detail-modal />
  </div>
</template>

<script>

import { fetchMerchantAppList } from '@/api/merchant-manage/merchant-manage'

export default {
  name: 'Develop_Manage_App_List',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    AddMerchantAppModal: () => import('./components/Modal/AddMerchantAppModal'),
    UpdateMerchantAppModal: () => import('./components/Modal/UpdateMerchantAppModal'),
    MerchantAppDetailModal: () => import('./components/Modal/MerchantAppDetailModal')
  },
  data() {
    return {
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  mounted() {
    this.$bus.off('RE_GER_MERCHANT_APP_LIST')
    this.$bus.off('RE_GER_MERCHANT_APP_LIST', () => {
      this.getMerchantAppList({})
    })
    this.getMerchantAppList({})
  },
  methods: {
    showUpdateMerchantAppModal(row) {
      this.$bus.emit('SHOW_UPDATE_MERCHANT_APP_MODAL', [true, row])
    },
    showMerchantAppDetailModal(row) {
      this.$bus.emit('SHOW_MERCHANT_APP_DETAIL_MODAL', [true, row])
    },
    handleFilter(params) {
      this.getMerchantAppList(params)
    },
    getMerchantAppList(params) {
      this.listLoading = true
      fetchMerchantAppList(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data.list
          this.listQuery.total = res.data.total
          this.listQuery.page = params.page ? params.page : 1
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    onClickAddBtn() {
      this.$bus.emit('SHOW_ADD_MERCHANT_APP_MODAL', [true])
    }
  }
}
</script>

<style lang="scss" scoped>
  .merchant-app-list{
    margin: 20px;
    background: #fff;
    border-radius: 4px;
  }
  .filter-container{
    padding: 24px;
    text-align: right;
  }
  .add-btn{
    color: #fff;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .edit-btn{
    margin: 10px 0;
  }
</style>
